module.exports = __webpack_public_path__ + "static/media/filter-mail.4a51a435.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/filter-mail.svg
// module id = 1568
// module chunks = 0